import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Options {
    onSuccess?: () => void;
}

export function useDeleteProjectTemplateMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (templateId: string) => {
            const res = await apiClient.deleteProjectTemplate({
                params: { templateId },
            });
            if (res.status !== 200) {
                throw new Error("Failed to delete template");
            }
            return res.body;
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ["templates"] });
            options?.onSuccess?.();
        },
    });
}
